module.exports = __webpack_public_path__ + "static/media/contract.ca7d307e.svg";